/* Position colours — §8. The palette is fixed and assigned in weight order, so a
   ticker keeps its colour between sessions as long as the ordering holds. The
   assignment is computed once per render pass from the sorted position list. */

export const POSITION_PALETTE = [
  '#7C6BFF', '#00D9FF', '#2BE59B', '#FFB020', '#FF5C8A', '#A78BFA',
  '#38BDF8', '#FF8A3D', '#4ADE80', '#818CF8', '#FCD34D', '#5B6880',
] as const;

export const CASH_COLOR = '#3A4560';

/** Maps tickers to colours by their rank in the weight ordering. Past the end of
    the palette the sequence repeats, which only happens beyond twelve names. */
export function assignColors(tickersByWeightDesc: string[]): Map<string, string> {
  const map = new Map<string, string>();
  tickersByWeightDesc.forEach((ticker, i) => {
    map.set(ticker, POSITION_PALETTE[i % POSITION_PALETTE.length]!);
  });
  return map;
}
